module.exports = __webpack_public_path__ + "img/CtrlRoom_music_0.89500a28.png";